<template>
    <div class="page" style="margin: 0 auto">
        <img class="image" :src="imgUrl + 'pc_1.png'" @click="onSubmit" />
        <img class="image" :src="imgUrl + 'pc_4.png'" />
        <img class="image" :src="imgUrl + 'pc_5.png'" />
        <img class="image" :src="imgUrl + 'pc_6.png'" />
        <img
            class="image"
            style="margin-bottom: 240px"
            :src="imgUrl + 'pc_7.png'"
        />
        <div style="position: fixed; bottom: 0; background: #ffffff">
            <div class="actionBar" @click="onSubmit">
                <img class="image" :src="imgUrl + (yxyOriginBool?'yxy_pc_8.png':xyOriginBool?'xy_pc_8.png':'pc_8.png')" />
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {},

        data () {
            return {
                xyOriginBool: false,
                yxyOriginBool: false,
                showLogin: false,
                imgUrl: "http://img.uelink.com.cn/upload/qsn_school_pc_web/",
            };
        },
        created() {
            var orgId = this.$route.query.orgId
            var examId = this.$route.query.examId
            // window.localStorage.setItem("orgId", orgId);
            // window.localStorage.setItem("examId", examId);
            // console.log(orgId, examId, "成功");
            this.$store.commit('user/SET_ORGID', orgId)
            this.$store.commit('user/SET_EXAMID', examId)
            const xyOriginBool = this.$store.state.user.xyOriginBool
            const yxyOriginBool = this.$store.state.user.yxyOriginBool
            if (xyOriginBool) {
                this.xyOriginBool = xyOriginBool
            }
            if (yxyOriginBool) {
                this.yxyOriginBool = yxyOriginBool
            }
        },
        computed: {},

        methods: {
            onSubmit () {
                this.$dialog
                    .alert({
                        title: "测评须知",
                        className: "logTips",
                        confirmButtonText: "我已了解",
                        confirmButtonColor: "#5b6ef9",
                        messageAlign: "left",
                        allowHtml: true,
                        message:
                            "<div style='font-size:26px;line-height: 36px;'>1、请在心态平和及时间充足的情况下才开始答题。\n2、注意！请仔细阅读题目，根据实际情况作答，题目的答案无对错之分，你不需要考虑哪个答案应该更好，也不要思考太久，凭心里的第一反应独立做出选择;\n3、为保证准确性，开始后请一次性完成，答题结束后会生成一份专业的测评报告。</div>",
                    })
                    .then(() => {
                        this.$router.push({
                            path: "/loginInfo",
                            query: {
                                orgId: this.orgId,
                            },
                        });
                    });
            },
        },
    };
</script>

<style lang="less">
    .logTips {
        width: 200px;
    }
    .page {
        background-color: #f8f9ff;
        font-size: 16px;
        font-family: -apple-system-font, Helvetica Neue, Helvetica, sans-serif;
        /* padding-bottom: 200rpx; */
    }
    .van-submit-bar__bar {
        // padding: 5px 10px;
        background: #fffcf9;
        box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.1);

        .btn {
            box-sizing: border-box;
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 40px;
            background-image: linear-gradient(180deg, #5a6ef9 0%, #5a6ef9 100%);
            box-shadow: inset 0 1px 0 0 #5a6ef9;
            border-radius: 25px;
            padding: 10px 0;
            color: #ffffff;
            letter-spacing: 1px;

            .btn-text1 {
                font-size: 14px;
                font-weight: bold;
                text-align: center;

                .send-text {
                    font-size: 12px;
                    font-weight: normal;
                    margin-top: 2px;
                    color: #5a6ef9;
                }
            }

            .btn-text2 {
                box-sizing: border-box;
                font-size: 17px;
                font-weight: bold;
            }

            .btn-text3 {
                box-sizing: border-box;
                font-size: 15px;
                font-weight: bold;
            }
        }
    }
    .mb {
        margin-bottom: 180rpx;
    }
    .actionBar {
        box-sizing: border-box;
        // width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        align-items: center;
        // height: 20px;
        // background-image: linear-gradient(180deg, #5a6ef9 0%, #5a6ef9 100%);
        // box-shadow: inset 0 1px 0 0 #5a6ef9;
        border-radius: 2px;
        // padding: 10px 0;
        color: #ffffff;
        font-size: 10px;
        letter-spacing: 1px;
    }

    .page__hd {
        padding: 30rpx;
    }
    .image {
        vertical-align: middle;
        margin-top: -1px;
    }

    .page__bd {
        padding: 30rpx;
    }

    .page__ft {
        padding-bottom: 10px;
        text-align: center;
    }

    .page__title {
        text-align: left;
        font-size: 40rpx;
        font-weight: 400;
        margin: 20rpx 0 20rpx 8rpx;
        display: flex;
        align-items: center;
    }

    .flex-row {
        display: flex;
        align-items: center;
    }

    .page__image {
        width: 690rpx;
        min-height: 100rpx;
        margin: 20rpx auto;
        /* border-radius: 16rpx; */
        display: block;
    }

    .page__desc {
        margin-top: 5px;
        color: #888888;
        text-align: left;
        margin: 20rpx 0 20rpx 8rpx;
        font-size: 24rpx;
        line-height: 2;
    }

    .weui-cell_example:before {
        left: 52px;
    }

    button::after {
        border: none;
    }

    .bottomBar {
        z-index: 100;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        -webkit-user-select: none;
        user-select: none;
        height: 100rpx;
        display: flex;
        flex-flow: row;
        justify-content: space-around;
    }

    .bottomBar .btn {
        line-height: 100rpx;
        flex: 1;
        border-radius: 0;
    }
    .row1 {
        flex: 1;
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        align-items: center;
    }

    .row3 {
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        align-items: center;
    }
    .row {
        flex: 1;
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
    }
    .row2 {
        flex: 1;
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        /* align-items: center; */
        /* justify-content: space-between; */
        margin-left: 8rpx;
    }
    .bg_fot {
        background: linear-gradient(to bottom, #5a6ef9, #5a6ef9, #5a6ef9);
        position: absolute;
        width: 750px;
        height: 334px;
        margin-top: -334px;
        z-index: -1;
        border-top-left-radius: 100%;
        border-top-right-radius: 100%;
    }
    .avatar {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-flow: row;
        color: #333333;
    }

    .avatar .img {
        border: 4px solid #f5f5f5;
        margin-right: 18px;
    }

    .tabs {
        margin: 0 0 20px;
    }

    .tabs .tab {
        border-radius: 40px;
        padding: 0 20px;
    }

    .topicAction {
        justify-content: flex-start;
        border-top: 1px dashed #cccccc;
        align-items: center;
        padding: 16px 0;
    }

    .questionTypeName {
        font-size: 26px;
    }

    .action {
        margin: 0 0 0 20px;
        color: #c5e1a5;
        display: flex;
        align-items: center;
    }

    .actionIcon {
        font-size: 26px;
        /* color: #576b95; */
        margin-right: 6px;
    }

    .unitName {
        font-size: 28px;
        color: #333333;
        line-height: 40px;
    }

    .score {
        font-size: 48px;
        color: #333333;
        line-height: 72px;
    }

    .f2-chart-c {
        width: 200px;
        height: 200px;
        display: block;
    }

    .f2-chart {
        width: 200px;
        height: 200px;
    }

    .panel-title {
        font-size: 28px;
        color: #5a6ef9;
        border-bottom: 1px solid #e8eaf6;
        padding: 0 10px 10px;
        border-radius: 0;
        /* justify-content: flex-start; */
    }

    .panel-title2 {
        font-size: 28px;
        color: #5a6ef9;
        /* border-bottom: 1px solid #e8eaf6; */
        padding: 0 10px 0px;
        justify-content: flex-start;
    }

    .status {
        font-size: 26px;
        color: #ffffff;
        /* border: 1px solid #9ccc65; */
        background-color: #5a6ef9;
        padding: 0px 24px;
        border-bottom-left-radius: 24px;
        height: 44px;
        line-height: 44px;
        margin: 0;
    }

    .workTitle {
        height: 44px;
    }

    .workTitleText {
        margin: 12px 0 0;
        font-size: 28px;
    }

    .listItem {
        margin-bottom: 20px;
        padding: 0px;
        overflow: hidden;
    }

    .listItem:last-child {
        margin-bottom: 0px;
    }

    .type {
        width: 0;
        height: 0;
        border-color: transparent #5a6ef9;
        /*上下颜色 左右颜色*/
        border-width: 0 0 80px 80px;
        border-style: solid;
    }

    .tag {
        font-size: 32px;
        color: #ffffff;
        margin: 0px 36px 0 -70px;
    }

    .date {
        font-size: 26px;
        margin: 0 6px 0 12px;
        color: #aaaaaa;
    }

    /* .panel-hd {
                overflow: hidden;
            } */

    .btn {
        justify-content: center;
        text-align: center;
        color: #ffffff;
        font-size: 24px;
        background: transparent;
        line-height: 60px;
        height: 60px;
        border-radius: 30px;
        margin: 10px 10px;
        /* flex: 1; */
    }

    .typeHover {
        padding: 10px 6px;
        height: 20px;
        border-radius: 20px;
        background-color: khaki;
    }

    .panel-ft {
        display: flex;
        flex-flow: row;
        font-size: 24px;
        color: #999999;
        align-items: center;
        justify-content: center;
        margin: 10px 0 0;
    }

    .projectImg {
        width: 128px;
        height: 128px;
        flex: 1;
        margin: 40px auto;
        display: block;
    }

    .grade {
        min-width: 106px;
        height: 80px;
        line-height: 80px;
        font-size: 24px;
        text-align: center;
        justify-content: center;
        border-radius: 12px;
        background-color: #eeeeee;
        color: #666666;
        padding: 0 12px;
        margin: 16px 12px;
    }
    .hover {
        background-color: #5a6ef9;
        color: #ffffff;
    }
</style>

